<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <v-col xl="5" lg="7" md="8" sm="10" cols="12">
            <v-form @submit.prevent="$refs.form?.isValid && submit()" ref="form">
                <v-text-field
                    :rules="$validation('required')"
                    label="* عنوان"
                    v-model="form.name"
                ></v-text-field>
                <v-textarea
                    :rules="$validation()"
                    no-resize
                    rows="3"
                    label="توضیحات"
                    model-value=""
                    v-model="form.description"
                ></v-textarea>
                <div class="mt-4">
                    <v-btn color="success" type="submit" :loading="loading">ثبت اطلاعات</v-btn>
                    <v-btn class="ms-3" color="error" @click="$router.push({path: '/settings/customerLevel' })" variant="text" :disabled="loading">بازگشت</v-btn>
                </div>
            </v-form>
        </v-col>
    </div>
</template>
<script>
export default {
    title: "ایجاد",
    validate(context) {
        return context.auth.user.full_admin && context.system.license.features.customer_level;
    },
    data() {
        return {
            loading: false,
            form: {
                name: null,
                description: null,
            },
        };
    },
    methods: {
        submit() {
            this.loading = true;
            this.$customerLevelStore(this.form).then((res) => {
                if (res && res.status == "CREATED") {
                    this.$toast.success(res.message);
                    this.$system.setSystemDefaults(true);
                    this.$router.push({path: '/settings/customerLevel' });
                }
            }).finally(()=>{this.loading = false});
        },
    },
};
</script>
